import { render, staticRenderFns } from "./BgImageUploader.vue?vue&type=template&id=95d92568&scoped=true&"
import script from "./BgImageUploader.vue?vue&type=script&lang=js&"
export * from "./BgImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./BgImageUploader.vue?vue&type=style&index=0&id=95d92568&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d92568",
  null
  
)

export default component.exports